import { scrollMixin } from 'theme/MuiThemeProvider/mixins';

export const styles = {
  wrap: {
    overflowY: 'auto',
    ...scrollMixin,
  },
};
